module.exports = __webpack_public_path__ + "static/img/return_bad_example_3.089e0df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/return_bad_example_3.jpg
// module id = TQp9
// module chunks = 1